import IntlMessages from '../../../util/IntlMessages';
import * as repairApi from '../../../api/repair';
import * as constants from '../../../constants';
import * as common from '../common';
import * as field from '../field';
import * as profile from '../info';

export const tankerRepairAddAction = () => async (dispatch, getState) => {
  dispatch(common.loadingBtnAction(true));
  await dispatch(profile.operatorProfileAction());
  let currentState = getState();
  let vMobileNumber = currentState.config.mobile;
  let vComment = currentState.field.comment;
  let iKilometer = parseInt(currentState.field.kilometer);
  let vFuelCarCode = currentState.field.fuelCarCode;

  if (vComment !== '' && vFuelCarCode !== '' && iKilometer !== '') {
    let result = await repairApi.tankerRepairAdd({
      vComment,
      iKilometer,
      vFuelCarCode,
      vMobileNumber,
      vOperatorName:
        currentState.field.profile.vFirstname +
        ' ' +
        currentState.field.profile.vLastname,
      iPersonType: constants.PERSON_TYPE,
    });

    dispatch(common.snackbarAction(true, result.message));
    if (result.status) {
      dispatch(field.setFields([{ data: '', field: 'comment' }]));
      dispatch(field.setFields([{ data: '', field: 'fuelCarCode' }]));
      dispatch(field.setFields([{ data: '', field: 'kilometer' }]));
    }
  } else {
    dispatch(common.snackbarAction(true, <IntlMessages id="starredFieldsAreRequired" />));
  }
  dispatch(common.loadingBtnAction(false));
};

export const tankerRepairByOperatorAction = () => async (dispatch, getState) => {
  let currentState = getState();
  let vMobileNumber = currentState.config.mobile;
  let result = await repairApi.tankerRepairByOperator({ vMobileNumber });
  if (result.status) dispatch(field.setFields([{ data: result.data, field: 'list' }]));
};
